import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";

import Dashboard from "@/views/Dashboard";
import ProspectingReport from "@/views/ProspectingReport/ProspectingReport";
import PageNotFound from "@/views/PageNotFound";

const routes = [
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      title: "Dashboard"
    }
  },
  {
    path: "/reports/benchmarking/:days",
    name: "ProspectingReport",
    component: ProspectingReport,
    meta: {
      title: "Prospecting Report"
    }
  },
  { path: "/:pathMatch(.*)*", component: PageNotFound }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  store.dispatch("app/setPageTitle", to.meta.title || null);

  next();
});

export default router;
